import { SVGProps, Ref, forwardRef } from 'react';

export const BulletOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m12 6-.413.009c-4.044.173-5.493 2.9-5.582 5.71L6 12c0 3 1.5 6 6 6s6-3 6-6-1.5-6-6-6m3.305 8.973c.583-.7.895-1.74.895-2.973s-.312-2.272-.895-2.973C14.769 8.385 13.817 7.8 12 7.8s-2.77.585-3.305 1.227c-.583.7-.895 1.74-.895 2.973s.312 2.272.895 2.973c.536.642 1.488 1.227 3.305 1.227s2.77-.585 3.305-1.227"
            fill="currentColor"
        />
    </svg>
));
BulletOutlinedSize24Glyph.displayName = 'BulletOutlinedSize24Glyph';
